var map = {
	"./academy-dev.js": 191,
	"./academy-local.js": 192,
	"./academy-preprod.js": 193,
	"./academy.js": 190,
	"./dev-v2.js": 195,
	"./dev.js": 194,
	"./index.js": 45,
	"./local.js": 196,
	"./preprod.js": 197,
	"./prod.js": 198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 633;